/**
 * Registry centralizado de z-index do app.
 *
 * Motivação:
 *  - Antes: cada componente tinha seu z-[N] hardcoded espalhado pelo código.
 *    Resultado: colisões impossíveis de debugar (Concierge atrás do Tour, etc.).
 *  - Agora: todos os layers ficam aqui, hierarquia documentada, ordem clara.
 *
 * Regra: use o constante exportado, não hardcode mais z-[X] em componentes.
 *
 * Hierarquia (do mais baixo pro mais alto):
 *  - Base content: 0-10
 *  - Sticky headers/footers: 20-40
 *  - Tab bar / nav: 50
 *  - Floating buttons / tooltips: 55-60
 *  - Modal dialogs: 60-90
 *  - Toasts (não bloqueantes): 100-120
 *  - GuidedTour (não pode ser interrompido facilmente): 130-145
 *  - Concierge (avisos importantes, acima do tour): 155-165
 *  - Update prompt / critical: 180-200
 *  - Coin shower / confetti (visual layer): 210
 */

export const Z = {
  /** Conteúdo padrão da página. */
  CONTENT: 0,
  /** Headers, footers grudados na rolagem. */
  STICKY: 30,
  /** Tab bar de navegação. */
  NAV: 50,
  /** Modals / dialogs. */
  MODAL: 70,
  /** Toasts informativos (useToast). */
  TOAST: 110,
  /** GuidedTour — tutorial passo a passo. */
  TOUR: 140,
  /** Concierge — acima do tour pra avisos críticos. */
  CONCIERGE: 165,
  /** Update prompt — versão nova disponível. */
  UPDATE_PROMPT: 190,
  /** Camada visual (confete, chuva de moedas). */
  VISUAL_FX: 210,
} as const;

export type ZLayer = keyof typeof Z;
